<template>
<div>
  <div v-for="comment in comments" class="d-flex mb-2">
    <template v-if="comment.who=='Ich'">
      <div class="d-flex align-center ml-auto">
        {{comment.who||'Unbekannt'}}
      </div>
      <div class="speech-bubble-right ml-4 mr-2 pa-2" style="min-width: 64px; min-height: 36px;">
        <span>{{comment.text}}</span>
      </div>
    </template>
    <template v-else>
      <div class="speech-bubble-left mr-4 ml-2 pa-2" style="min-width: 64px; min-height: 36px;">
        <span>{{comment.text}}</span>
      </div>
      <div class="d-flex align-center mr-auto">
        {{comment.who||'Unbekannt'}}
      </div>
    </template>
  </div>
  <div class="d-flex mb-2">
    <div class="d-flex align-center ml-auto">
      Ich
    </div>
    <div class="speech-bubble-right ml-4 mr-2" style="min-width: 64px; min-height: 36px;">
      <v-btn text class="ma-1" v-if="!writingComment" @click="addComment">
        <div class="display-1 mt-n4">...</div>
      </v-btn>
      <v-textarea v-show="writingComment" class="ma-3" rows="1" auto-grow color="accent" ref="textarea"
            outlined hide-details
            name="comment"
            label="Mein Kommentar"
            v-model="commentText"
            @focusout="onFocusOut"
        ></v-textarea>
      <div class="d-flex" v-if="writingComment">
        <v-btn text  class="d-flex mt-n2 mb-1 ml-1" @click="onCancel">
          Abbrechen
        </v-btn>
        <v-btn text  class="d-flex mt-n2 mb-1 mr-1" @click="onSave">
          Speichern
        </v-btn>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Activity from "@/components/Activity";
import Datum from "@/components/Datum";
import Kinds from "@/components/Kinds";

export default {
  name: "Comments",
  props: ['date', 'bereich'],
  data() {return {
    writingComment: false,
    commentText:undefined,
    comments: [],
  }},
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      var bereich=this.bereich;
      var date = Datum.to_iso(this.date);
      this.comments = await this.$backend.get_filtered_objects(Kinds.KIND_COMMENT, {bereich, date});
    },
    addComment() {
      this.writingComment=true;
      this.$nextTick(()=>this.$refs.textarea.focus());
    },
    async onSave() {
      var text = this.commentText;
      await this.saveNewComment(text);
      this.writingComment=false;
      this.commentText=undefined;
    },
    onCancel() {
      this.writingComment=false;
      this.commentText=undefined;
    },
    onFocusOut() {
      if (!this.commentText)
        this.writingComment=false;
    },
    async saveNewComment(text) {
      var date = this.date;
      var bereich = this.bereich;
      var comment = { bereich: bereich, date: Datum.to_iso(date), text, who:"Ich"};
      console.log("saving new comment", {comment});
      // id and timestamp props will be generated by server!
      await this.$backend.set_object(Kinds.KIND_COMMENT, "timestamp", comment);
      await this.load();
      //this.$events.$emit("notify", "Gespeichert");
    },
  },
  watch: {
    bereich() {
      this.load();
    },
    date() {
      this.load();
    },
  }
}
</script>

<style scoped>
  .speech-bubble-right {
    position: relative;
    background: #fffee5;
    border-radius: 4px;
    filter: drop-shadow(0px 2px 2px #00000066);
  }

  .speech-bubble-right:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-right-color: #fffee5;
    border-left: 0;
    margin-top: -8px;
    margin-left: -8px;
  }

  .speech-bubble-left {
    position: relative;
    background: #e5feff;
    border-radius: 4px;
    filter: drop-shadow(0px 2px 2px #00000066);
  }

  .speech-bubble-left:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: #e5feff;
    border-right: 0;
    margin-top: -8px;
    margin-right: -8px;
  }

  .rot90 {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
</style>